module.exports = __webpack_public_path__ + "static/media/galeryCeilings6.c633d37d.jpg";